import React, { useContext } from "react";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OwPrintButton from "../../shared/OwPrintButton/OwPrintButton";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import SupplierContext from "../../../contexts/SupplierContext";
import { OrderCreateSalesOrderView } from "./OrderCreateSalesOrderView/OrderCreateSalesOrderView";
import { FormattedMessage } from "react-intl";
import { OrderTotalsPanel } from "../../order_entry/OrderTotalsPanel/OrderTotalsPanel";
import { useBulkDocumentOrders } from "../../../hooks/orders/useBulkDocumentOrders";
import "./OrderCreateSalesOrder.scss";

type Props = {
    /**
     * @deprecated
     */
    toggleMenu: () => void;
};

const navItems: IBreadcrumbs[] = [
    { title: "Dashboard", url: "/dashboard" },
    { title: "Orders", url: "/orders" },
    {
        title: "Sales Order",
        url: "",
    },
];

/**
 * Prints one Sales Order per order named in the query string (`?orders=a,b,c`), each on its own
 * page, so several orders selected on the Orders screen can be produced in one go.
 */
export const OrderCreateSalesOrder: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);

    const { orders, loaded } = useBulkDocumentOrders("Sales Order");

    return (
        <div className="OrderCreateSalesOrder col-12 mt-2 pb-5">
            <div className={"row mb-2 d-flex justify-content-between align-items-center flex-wrap"}>
                <div className={"d-inline-flex"}>
                    <Breadcrumbs hasTopMargin={false} navItems={navItems} />
                </div>
                <div className="d-flex justify-content-end align-items-center">
                    <OwPrintButton />
                </div>
            </div>

            {orders.map((order) => {
                return (
                    <div key={order.guid} className={"DocumentContainer"}>
                        <OrderCreateSalesOrderView order={order} showPhone={true} showEmail={true} showSku={true} showUpc={true} />

                        <div className={"row"}>
                            <div className={"col-12 justify-content-end d-flex"}>
                                <OrderTotalsPanel
                                    shouldHidePricingFn={() => {
                                        return false;
                                    }}
                                    shouldHideTaxJarName={true}
                                    order={order}
                                    orderItemType={"standard"}
                                    isReadOnly={true}
                                    lineView={true}
                                />
                            </div>
                        </div>

                        {supplierModel.sales_order_footer ? <div className={"text-center"}>{supplierModel.sales_order_footer}</div> : null}
                    </div>
                );
            })}

            {loaded && !orders.length ? (
                <div className={"text-center mt-4"}>
                    <FormattedMessage id="no_orders_found" defaultMessage="No Orders Found" description="No Orders Found" />
                </div>
            ) : null}
        </div>
    );
};
